import { useI18n } from '../i18n/I18nContext';

export default function LanguageSelector() {
  const { locale, setLocale } = useI18n();

  const choices = [
    { code: 'en', label: 'EN' },
    { code: 'zh', label: '中文' }
  ];

  return (
    <div className="inline-flex overflow-hidden rounded-full border border-slate-200 text-xs font-medium">
      {choices.map((c) => (
        <button
          key={c.code}
          type="button"
          onClick={() => setLocale(c.code)}
          className={`px-3 py-1.5 transition ${
            locale === c.code ? 'bg-coverfy-accent text-white' : 'bg-white text-slate-600 hover:bg-slate-50'
          }`}
        >
          {c.label}
        </button>
      ))}
    </div>
  );
}
